import { useState, type ReactNode } from 'react'
import { PageHeaderContext, type HeaderState } from '@/components/page-header-context'

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [header, setHeader] = useState<HeaderState>({ title: 'Amine Taxi' })
  return (
    <PageHeaderContext.Provider value={{ ...header, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  )
}
